import {Button, Col, Image, Row} from "react-bootstrap";
import Container from "react-bootstrap/Container";

function Home() {
    return (
        <div className="bg-gradient-dark">
            <Container>
                <Row xs={2}>
                    <Col>
                        <Image src="https://storage.googleapis.com/milky-way-trail-website-storage/website-images/game_dev_logo-2.png" fluid/>
                    </Col>
                    <Col>
                        <h1 className="display-1 text-white fw-bolder" style={{
                            marginTop: "30%",
                            paddingBottom: "5%",
                            fontSize: "120px"
                        }}>Milky <br/> Way Trail</h1>
                        <Button variant="warning" href="/games"><strong>Explore Games</strong></Button>
                    </Col>
                </Row>
            </Container>

        </div>
    );
}

export default Home;